import { useState } from "react";
import { useSelector } from "react-redux";
import { useGetDiscrepancyListQuery } from "../../../../redux/services/SPL";
import { ReactComponent as ArrowCircle } from '../../../../assets/images/icon_svg/arww_wth_crcl.svg';
import { ReactComponent as GreenTick } from '../../../../assets/images/icon_svg/close_history.svg';
import { ReactComponent as YellowExclm } from '../../../../assets/images/icon_svg/infoIcon.svg';
import DiscrepancyModal from "./DiscrepancyModal";
import TableGrid from "../../../../Components/common/TableGrid";

const SectionBanner = ({ type }) => {
  const isOpen = type === "open";
  return (
    <div
      className="d-flex align-items-center gap-2"
      style={{
        backgroundColor: isOpen ? "#FFFBEB" : "#DCFCE7",
        borderBottom: `1px solid ${isOpen ? "#fde68a" : "#bbf7d0"}`,
        padding: "10px 16px",
      }}
    >
      {isOpen ? <YellowExclm width={15} height={15} /> : <GreenTick  width={15} height={15} />}
      <span
        style={{
          fontWeight: 600,
          fontSize: "12px",
          letterSpacing: "0.05em",
          color: isOpen ? "#BB4D00" : "#008236",
        }}
      >
        {isOpen ? "OPEN DISCREPANCIES" : "RESOLVED DISCREPANCIES"}
      </span>
    </div>
  );
};

const Discrepancies = ({ onDetails }) => {
  // const raw = localStorage.getItem("DetailsTitle") || "";
  const raw = localStorage.getItem("TODetails") || "";
  // const truckId = raw.split("/")[0];
  const truckId = raw;
  const { pageDetails, filters, sortby } = useSelector((state) => state.table);
  const [showDiscrepancyModal, setShowDiscrepancyModal] = useState(false);
  const [selectedDiscrepancy, setSelectedDiscrepancy] = useState(null);

  const actionColumn = {
    label: "",
    field: "action",
    cls: "tw-2" ,
    renderCell: (row) =>
      !row?.is_resolved ? (
        <ArrowCircle
        width={23} height={23}
          style={{ cursor: "pointer", marginTop:"-3px" }}
          onClick={() => {
            setSelectedDiscrepancy(row);
            setShowDiscrepancyModal(true);
          }}
        />
      ) : null,
  };

  const openColumns = [
    actionColumn,
    { label: "TYPE",      field: "type",      renderCell: (row) => <span className="type">{row?.list?.title || ""}</span>, cls: "tw-15" },
    { label: "CATEGORY",  field: "category",  renderCell: (row) => <span className="category">{row?.detail?.discrepancy_summary?.category || ""}</span>,cls: "tw-10"  },
    { label: "RAISED AT", field: "raised_at", renderCell: (row) => row?.detail?.discrepancy_summary?.identified_on || "",cls: "tw-10"  },
    { label: "RAISED BY", field: "raised_by", renderCell: (row) => row?.created_by || "" },
  ];

  const resolvedColumns = [
    actionColumn,
    { label: "TYPE",        field: "type",        renderCell: (row) => <span className="type">{row?.list?.title || "" }</span>, cls: "tw-15"  },
    { label: "CATEGORY",    field: "category",    renderCell: (row) => <span className="category">{row?.detail?.discrepancy_summary?.category || ""}</span>, cls: "tw-10"  },
    { label: "RAISED AT",   field: "raised_at",   renderCell: (row) => row?.detail?.discrepancy_summary?.identified_on || "", cls: "tw-10"  },
    { label: "RAISED BY",   field: "raised_by",   renderCell: (row) => row?.created_by || "", cls: "tw-10"  },
    { label: "RESOLVED ON", field: "resolved_on", renderCell: (row) => row.resolved_on?.slice(0, 16) || "", cls: "tw-10"  },
    { label: "RESOLVED BY", field: "resolved_by", renderCell: (row) => row.resolved_by || "" },
  ];

  const baseParams = {
    truckId,
    pagenum: pageDetails.pagenum,
    pagesize: pageDetails.pagesize,
    recordstartindex: pageDetails.recordstartindex,
    recordendindex: pageDetails.recordendindex,
  };

  const skipQuery = !truckId;
  const queryOptions = { skip: skipQuery, refetchOnMountOrArgChange: true };

  const { data: openData,     isFetching: openFetching     } = useGetDiscrepancyListQuery({ ...baseParams, tab: "O" }, queryOptions);
  const { data: resolvedData, isFetching: resolvedFetching } = useGetDiscrepancyListQuery({ ...baseParams, tab: "C" }, queryOptions);

  return (
    <>
      <div className="table-wrapper mb-4 dis_list">
        <SectionBanner type="open" />
        <TableGrid
          columns={openColumns}
          rows={openData?.Rows || []}
          loading={openFetching}
          rowKey="id"
          disablePagination
          disableSortby
        />
      </div>

      <div className="table-wrapper mb-4 dis_list">
        <SectionBanner type="resolved" />
        <TableGrid
          columns={resolvedColumns}
          rows={resolvedData?.Rows || []}
          loading={resolvedFetching}
          rowKey="id"
          disablePagination
          disableSortby
        />
      </div>

      <DiscrepancyModal
        key={selectedDiscrepancy?.id}
        show={showDiscrepancyModal}
        onHide={() => { setShowDiscrepancyModal(false); setSelectedDiscrepancy(null); }}
        truckData={selectedDiscrepancy}
        timeComp={[]}
        onDetails={onDetails}
      />
    </>
  );
};

export default Discrepancies;